import React from 'react';
import styles from './CustomCard.module.css';
import CustomText from '../customText/CustomText';
import image from '../../assets/img/project_image.jpg';
import { useTranslation } from 'react-i18next';
import colors from '../../styles/colors';
import CustomImage from '../customImage/CustomImage';
import CustomChips from '../customChips/CustomChips';
import { ReactComponent as IconHeart } from '../../assets/icons/icon_heart.svg';
import { ReactComponent as IconHeartActive } from '../../assets/icons/icon_heart_active.svg';
import { ReactComponent as IconShare } from '../../assets/icons/icon_share.svg';
import CustomButton from '../customButton/CustomButton';

type CustomCardProps = {
    data: CustomCardType;
    onLike?: Function;
    onClick: any;
    onShare: Function;
    imageAlt: string;
    imageUrl: string;
    hoverText: string;
    className?: any;
}

const CustomCard = (props: CustomCardProps) => {
    
    const {t} = useTranslation();

    const cutString = (texte: string, max: number) => texte.length <= max ? texte : (texte.slice(0, max - 1).replace(/\s$/, '') + '…');

    return (
        <div className={`${props.className} ${styles.card}`} onClick={props.onClick} role="button">
            <div className={styles.image_container}>
                <CustomImage
                    alt=""
                    src={props.imageUrl || image}
                    className={styles.image}
                />

                <div className={styles.image_cover}>
                    <CustomButton
                        buttonType='outlined'
                        sx={{
                            textTransform: 'uppercase',
                            color: `${colors.darkBlue}!important`,
                            backgroundColor: colors.white
                        }}
                        disabled
                    >{props.hoverText}</CustomButton>
                </div>
            </div>

            { props.data.price !== undefined &&
                <CustomChips backgroundColor={props.data.price > 0 ? colors.gold : colors.blue}>
                    {props.data.price > 0 ? t('store.premium') : t('store.free')}
                </CustomChips>
            }

            <CustomText bold className={styles.title}>{props.data.title}</CustomText>
            <CustomText className={styles.paragraph}>{cutString(props.data.description, 70)}</CustomText>

            <div className={styles.interactions_container}>
                { props.onLike &&
                    <div role='button' tabIndex={0} onClick={(e) => {e.stopPropagation();props.onLike && props.onLike(props.data)}}>
                        <span className={styles.iconContainer}>
                            {props.data.isLiked ? <IconHeartActive /> : <IconHeart />}
                        </span>
                        <CustomText className={styles.interactions_text}>{props.data.likes?.length}</CustomText>
                    </div>
                }
                
                <div role="button" tabIndex={0} onClick={(e) => {e.stopPropagation();props.onShare();}}>
                    <span className={styles.iconContainer}><IconShare /></span>
                    <CustomText className={styles.interactions_text}>{t('general.share')}</CustomText>
                </div>
            </div>
        </div>
    );
}

export default CustomCard;